// Estados de OC que cuentan como "pendiente por llegar" — compartido entre
// PurchaseOrdersDeliveryModule (Pedidos de compra) y EntryModule (Entrada,
// selector de OC a recepcionar) para que ambos siempre miren el mismo set.
export const PENDING_OC_STATUSES = ['Emitida', 'En tránsito', 'Parcial'];
